<template>
  <el-dialog :title="type === 'update' ? '编辑账号' : '新增账号'"
             :visible.sync="visible"
             width="600px"
             append-to-body
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             @closed="handleClose">
    <el-form ref="ruleForm"
             :model="info"
             :rules="rules"
             label-width="95px">
      <el-form-item label="账号："
                    prop="account">
        <el-input v-model="info.account"
                  :disabled="type === 'update'"></el-input>
      </el-form-item>
      <el-form-item label="姓名："
                    prop="staffName">
        <el-input v-model="info.staffName"></el-input>
      </el-form-item>
      <el-form-item label="手机号："
                    prop="mobile">
        <el-input v-model="info.mobile"></el-input>
      </el-form-item>
      <el-form-item label="功能权限"
                    v-if="userPermission.ENT_ADMIN"
                    prop="functions">
        <checkbox-tree :treeData="menuNodes"
                       nodeKey="funcId"
                       :defaultProps="defaultProps"
                       v-model="info.functions" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button :loading="loading"
                 @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button type="primary"
                 :loading="loading"
                 @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import CheckboxTree from '@/components/public/checkbox-tree.vue'
import { guid } from '@/utils/index'
export default {
  name: 'edit-staff-modal',
  components: { CheckboxTree },
  props: {
    callback: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      menuNodes: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      info: {
        account: '',
        staffName: '',
        mobile: '',
        functions: []
      },
      type: 'add',
      rules: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        staffName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        functions: [
          { required: true, message: '功能权限不能为空', trigger: 'change' }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.info = {
        account: '',
        staffName: '',
        mobile: '',
        functions: []
      }
    },
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch =
            this.type === 'update' ? (this.userPermission.ENT_ADMIN ? 'updatestaff' : 'updateme') : 'addstaff'
          this.$store.dispatch(`staff/${dispatch}`, {
            payload: {
              ...this.info,
              userType: 100,
              password: '123456',
              functions: this.info.functions.filter(item => typeof item === 'number').map(item => ({ funcId: item }))
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getportalmenutree2orgtype () {
      this.loading = true
      this.$store.dispatch('staff/getorgportalmenutree', {
        payload: {
          orgType: 100
        },
        success: res => {
          this.loading = false
          res.data.menuNodes.forEach(item => {
            if (!item.funcId) {
              item.funcId = `custom-${guid()}`
            }
          })
          this.menuNodes = res.data.menuNodes.map(i => {
            let disabled = this.info.isAdmin === 1
            i.disabled = disabled
            i.children = i.children ? i.children.map(s => {
              s.disabled = disabled
              return s
            }) : []
            return i
          })
        },
        fail: () => {
          this.loading = false
          this.menuNodes = []
        }
      })
    },
    init (options = {}, type) {
      this.info = {
        ...this.info,
        ...options
      }
      this.type = type
      if (this.userPermission.ENT_ADMIN) {
        this.getportalmenutree2orgtype()
      }
      this.toggleModal(true)
    }
  }
}
</script>
